import { render, staticRenderFns } from "./JsonParser.vue?vue&type=template&id=3a53731e&"
import script from "./JsonParser.vue?vue&type=script&lang=ts&"
export * from "./JsonParser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports